import { Inject, Injectable, InjectionToken } from '@angular/core';
import { NotificationItem } from '../models/notification-item';


export const NOTIFICATION_INFO_TRANSFORMERS = new InjectionToken<NotificationInfoTransformer>('NOTIFICATION_INFO_TRANSFORMERS');

@Injectable({
  providedIn: 'root'
})
export class NotificationInfoHandler {

  constructor(@Inject(NOTIFICATION_INFO_TRANSFORMERS) private transformers: NotificationInfoTransformer[]) { }

  getTransformer(systemCode: string): NotificationInfoTransformer | undefined {
    return this.transformers.find(x => x.systemCode === systemCode);
  }
}

export interface NotificationInfoTransformer {
  systemCode: string;
  getTitle(value: NotificationItem): string;
  getContent(value: NotificationItem): string;
}
